import React, { useEffect, useState } from "react";
import PageHero from "../components/PageHero";
import { api } from "../lib/api";
import { Clock, MapPin, UserCircle } from "lucide-react";
import { Badge } from "../components/ui/badge";

export default function SchoolLife() {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("Semua");
  useEffect(() => { api.get("/extracurriculars?limit=100").then(({ data }) => setItems(data.items)).catch(() => {}); }, []);
  const categories = ["Semua", ...Array.from(new Set(items.map((i) => i.category)))];
  const filtered = cat === "Semua" ? items : items.filter((i) => i.category === cat);

  return (
    <div data-testid="school-life-page">
      <PageHero
        eyebrow="Kehidupan Sekolah"
        title="Lebih dari Sekadar Belajar"
        subtitle="Ekstrakurikuler, organisasi, dan kegiatan yang membentuk karakter, bakat, dan kepemimpinan murid SMAS YPK 2 Biak."
        image="https://images.unsplash.com/photo-1529333166437-7750a6dd5a70?w=2000&q=80"
      />
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex flex-wrap gap-2 mb-10">
            {categories.map((c) => (
              <button
                key={c}
                data-testid={`filter-${c.toLowerCase()}`}
                onClick={() => setCat(c)}
                className={`px-4 py-2 rounded-full text-sm font-semibold transition-colors ${
                  cat === c ? "bg-[#0B1D3A] text-white" : "bg-slate-100 text-slate-700 hover:bg-slate-200"
                }`}
              >{c}</button>
            ))}
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((e) => (
              <div key={e.id} data-testid={`ekskul-${e.id}`} className="card-elevated overflow-hidden">
                <div className="aspect-video overflow-hidden">
                  <img src={e.photo_url} alt={e.name} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="p-6">
                  <Badge className="bg-amber-50 text-amber-700 border-amber-200 text-[11px] font-semibold uppercase tracking-wider">{e.category}</Badge>
                  <div className="font-serif text-xl font-bold text-[#0B1D3A] mt-3">{e.name}</div>
                  <p className="mt-2 text-sm text-slate-600 line-clamp-3">{e.description}</p>
                  <div className="mt-4 pt-4 border-t border-slate-100 space-y-1.5 text-xs text-slate-500">
                    {e.coach && <div className="flex gap-2"><UserCircle className="w-3.5 h-3.5" /> {e.coach}</div>}
                    {e.schedule && <div className="flex gap-2"><Clock className="w-3.5 h-3.5" /> {e.schedule}</div>}
                    {e.location && <div className="flex gap-2"><MapPin className="w-3.5 h-3.5" /> {e.location}</div>}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
